import {
  ExternalTransaction,
  RootIdType,
  TransactionTypeEnum,
  TransactionTypeKey,
} from '@helios/common-api'
import { Command } from '@helios/state-management'

export const BULK_EXT_TRAN_LIMIT = 30_000

export interface BulkExternalTransactionsGetRequest {
  filter: BulkExternalTransDataFilter
}

export interface BulkExternalTransactionsGetResponse {
  data: ExternalTransaction[]
  matchingTransCount: string
}

export interface BulkExternalTransDataStatuses {
  filterType: string
  values?: string[]
}

export interface BulkExternalTransDataFilter {
  accountIds?: number[]
  clientIds?: number[]
  externalTranIds?: number[]
  beginDate?: string
  endDate?: string
  securityIds?: number[]
  tranTypes?: string[]
  assetIds?: string[]
  dataSourceType?: string[]
  status?: BulkExternalTransDataStatuses
}

export interface FindBulkExternalTransactionsForm {
  rootIdType?: RootIdType
  rootIds?: string
  startDate?: string
  endDate?: string
  assetIds?: string
  tranTypes?: string[]
  statuses?: string[]
  dataSourceType?: string[]
}

export interface TranTypeSetValue {
  type: TransactionTypeKey // this the key in tran type enum
  name: string // this is actually tran type code
}

export interface BulkExtTranType {
  name: TransactionTypeEnum
  code: string
}

export interface BulkExtTranSetValues {
  tranTypes: TranTypeSetValue[]
  dataSourceType: string[]
  status: string[]
}

export interface BulkExternalTransaction extends ExternalTransaction {
  isEdited?: boolean
  transactionBasis?: string[]
}

export type BulkExternalTransactionActionType =
  | 'IGNORE'
  | 'UNIGNORE'
  | 'HOLD'
  | 'UNHOLD'
  | 'POST'

export interface BulkExternalTransactionActionResult {
  bulkExtTransValidationResult: {
    commands: Command[]
    extTranId: number
    successful: boolean
  }[]
  commands: Command[]
}
